import keyMirror from 'keymirror'

const CatToolConstants = keyMirror({
  SHOW_CONTAINER: null,
  TOGGLE_CONTAINER: null,
  CLOSE_SUBHEADER: null,
  SET_SEGMENT_FILTER: null,
  CLOSE_SEARCH: null,
  RELOAD_SEGMENT_FILTER: null,
  STORE_FILES_INFO: null,
  SET_PROGRESS: null,
  UPDATE_QR: null,
  RELOAD_QR: null,
  STORE_SEARCH_RESULT: null,
  CLIENT_CONNECT: null,
  CLIENT_RECONNECTION: null,
  ADD_NOTIFICATION: null,
  REMOVE_NOTIFICATION: null,
  REMOVE_ALL_NOTIFICATION: null,
  ON_RENDER: null,
  UPDATE_TM_KEYS: null,
  UPDATE_DOMAINS: null,
  HAVE_KEYS_GLOSSARY: null,
  OPEN_SETTINGS_PANEL: null,
  GET_JOB_METADATA: null,
  SEGMENT_FILTER_ERROR: null,
  SET_FIRST_LOAD: null,
})

export default CatToolConstants
